import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'
import moment from 'moment'


import {
    isPrimitive,
    trayecto,
    pasajero,
    solicitudcenco,
    foro
} from '../utils/helpers'
import { stat } from 'fs';


const INITIAL_STATE = Immutable.fromJS({
    fecha_solicitud: moment().format('YYYY-MM-DD'),
    motivo_viaje: null,
    tipo_viaje: 1,
    asistencia_viajero: false,
    tipo_trayecto: 1,
    cant_pasajeros: 1,
    tiquete_comprado: null,
    adjuntos: [],
    observaciones: '',
    trayectos: [trayecto()],
    pasajeros: [pasajero()],
    btnSaveDisabled: false,
    cencos: [],
    tipo: 4,
    foros:[],
    comentario: {
        guid: null,
        texto: null
    },
    flagAdjunto: false
})


export default function (state = INITIAL_STATE, action) {

    let index, trayectos, pasajeros,adjuntos;

    switch (action.type) {

        case types.REINICIAR_SOLICITUD_TIQUETESAEREO:
            return INITIAL_STATE

        case types.MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO:

            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }



            if (state.get('cant_pasajeros') > state.get('pasajeros').count()) {
                for(let i=state.get('pasajeros').count(); i < state.get('cant_pasajeros'); i++) {
                    state = state.setIn(['pasajeros',i], Immutable.fromJS(pasajero()))
                }
            }

            if (state.get('cant_pasajeros') < state.get('pasajeros').count()) {
                pasajeros = state.get('pasajeros').toJS().splice(0,state.get('cant_pasajeros'))
                state = state.set('pasajeros', Immutable.fromJS(pasajeros))
            }

            if (action.payload.path == 'tipo_viaje') {

                if (action.payload.value == 1) {
                    state = state
                    .setIn(['pasajeros', 0, 'cedula'], null)
                    .setIn(['pasajeros', 0, 'pasaporte'], null)
                    .setIn(['pasajeros', 0, 'pais_expedicion'], null)
                    .setIn(['pasajeros', 0, 'fecha_caducidad_pasaporte'], null)
                    .setIn(['pasajeros', 0, 'pasaporte_adjunto'], null)
                }

                if (action.payload.value == 2) {
                    state = state
                    .setIn(['pasajeros', 0, 'cedula'], null)
                    .setIn(['pasajeros', 0, 'pasaporte'], null)
                    .setIn(['pasajeros', 0, 'nacionalidad'], null)
                    .setIn(['pasajeros', 0, 'pais_expedicion'], null)
                    .setIn(['pasajeros', 0, 'fecha_caducidad_pasaporte'], null)
                    .setIn(['pasajeros', 0, 'pasaporte_adjunto'], null)
                }
            }

            if (action.payload.path == 'tipo_trayecto' && action.payload.value != 3) {
                trayectos = state.get('trayectos').toJS().splice(0,1)
                state = state.set('trayectos', Immutable.fromJS(trayectos))
            }



            if (action.payload.path == 'tipo_trayecto' && action.payload.value != 1) {
                state.get('pasajeros').map((p,i) => {
                    state = state.setIn(['pasajeros', i, 'asistencia', 'fecha_regreso'], null)
                })
            }

            return state

        case types.ADICIONAR_TRAYECTO:
            index = state.get('trayectos').count()
            state = state.setIn(['trayectos',index], Immutable.fromJS(trayecto()))
            return state



        case types.REMOVER_TRAYECTOS:
            state = state.update('trayectos', list => list.filter(x => !x.get('selected')))
            return state



        case types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO:
            state = state.set('btnSaveDisabled', action.payload)
            return state


        case types.ADICIONAR_PASAPORTE:
            state = state.setIn(['pasajeros', action.payload.index, 'pasaporte_adjunto'], action.payload.data)
            return state



        case types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO:
            state = state.setIn(action.payload.path.split('.'),  Immutable.fromJS(action.payload.value))
            return state


        case types.ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO:
            let actual = state.get('cencos').reduce((a ,b) => { a += Number(b.get('porcentaje')); return a }, 0)
			state = state.update('cencos', list => list.push(Immutable.fromJS(solicitudcenco(actual))))
            return state


        case types.REMOVER_CENCOS_TIQUETESAEREOS:
            state = state.update('cencos', list => list.filter(x => !x.get('selected')))
            return state


        case types.ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            if(index === -1){
                const data = Immutable.fromJS(foro(action.payload.usuario, action.payload.comentario))
                state = state.set('foros', state.get('foros').push(data))
            }else{
                state = state.setIn(['foros', index, 'comentario'], action.payload.comentario)
            }
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

        case types.EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.setIn(['comentario','guid'], action.payload.guid)
            state = state.setIn(['comentario','texto'], state.getIn(['foros', index, 'comentario']))
            return state

        case types.ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.deleteIn(['foros', index])
            return state
        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1:
            index = action.payload
            adjuntos = state.get('adjuntos').findIndex(x => x.get('guid') === index.get('guid'))
            index = index.set('nombre', `${index.get('nombre')}`)
            if (adjuntos === -1) {
                state = state.set('adjuntos', state.get('adjuntos').push(index))
            } else {
                index = index.set('updated', true)
                state = state.setIn(['adjuntos', String(adjuntos)], index)
            }
            return state
        case types.ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO:
            state = state.update('adjuntos', list => list.filter(x => !x.get('selected')))
            return state
       	default:
            return state


    }

}



// WEBPACK FOOTER //
// ./src/reducers/creaciontiqueteaereo.js